<div class="flex flex-col w-full">
  <div class="grid upload-image sm:grid-cols-1 w-full">
    <mat-label class="mb-1">{{field?.props?.label}} @if (field?.props?.required && field?.props?.label) {
      <span class="mat-mdc-form-field-required-marker mdc-floating-label--required font-normal"></span>
    }</mat-label>
    <ngx-file-drop class="relative bg-white" [accept]="accept()" [multiple]="field?.props?.multiple || false" (onFileDrop)="onSelect($event)">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div (click)="openFileSelector()">
          <div class="absolute top-1/2 left-0 w-full transform -translate-y-1/2">
            @if (!hasFiles()) {
              <img class="w-22 mx-auto file-upload-media" src="assets/images/add-item-upload.png" alt="Upload Img">
              <p class="text-center text-bring-blue">{{ field?.props?.message || 'Upload media' }}</p>
            }
            @if (hasFiles()) {
              <div class="px-3 overflow-y-auto h-30 flex gap-4 flex-wrap">
                @for (file of files(); track file; let i = $index) {
                  <div class="w-26">
                    <div class="relative preview-img justify-center items-center border-2 h-[6.4rem]" [class.flex]="!file.isLoading">
                      @if (file.isLoading) {
                        <img class="object-cover" [src]="'assets/images/loader.svg'" [alt]="'Loading'" />
                      }
                      @if (!file.isLoading && file.type?.startsWith('image')) {
                        <img [src]="file.imageUrl" [alt]="file.name" />
                      } @else {
                        <div class="relative">
                          <mat-icon class="icon-size-14 text-hint opacity-50" [svgIcon]="'heroicons_solid:document'"></mat-icon>
                          <div
                            class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                            [ngClass]="file.name | fileExtensionColor"
                            >
                            {{file.name | fileExtension}}
                          </div>
                        </div>
                      }
                      <p class="cursor-pointer absolute top-1 right-1" (click)="onRemove(file); $event.stopPropagation()">
                        <mat-icon class="bg-gray-500 hover:duration-600 hover:bg-gray-800 rounded-full text-white icon-size-5" [svgIcon]="'close'"></mat-icon>
                      </p>
                    </div>
                    <p class="text-secondary mt-0.5 text-center text-sm truncate leading-4">{{ file.name }}</p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </ng-template>
    </ngx-file-drop>
  </div>
</div>